module.exports = __webpack_public_path__ + "355CC9_1_0.woff?234fc74e9d3be9508336c6a51724e048";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/355CC9_1_0.woff
// module id = 35
// module chunks = 0